//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class UserNameModel extends ModelBase {
      static readonly $typeName = 'UserNameModel';
      public firstName: string;
      public lastName: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/UserNameModel.ts